import { render, staticRenderFns } from "./SelectService.vue?vue&type=template&id=2503fc24&scoped=true"
import script from "./SelectService.vue?vue&type=script&lang=js"
export * from "./SelectService.vue?vue&type=script&lang=js"
import style0 from "./SelectService.vue?vue&type=style&index=0&id=2503fc24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2503fc24",
  null
  
)

export default component.exports